import getScrollPositionOfPage from 'commons/getScrollPositionOfPage';

const getTopPositionOfElement = element => {
  if (!element) {
    return null;
  }

  const boundingRect = element.getBoundingClientRect();
  const topOfElement = getScrollPositionOfPage() + boundingRect.top;

  return topOfElement;
};

export default getTopPositionOfElement;
